export default __webpack_public_path__ + "static/media/Resume-Franciane-Ribeiro-Póvoa.8ab81525.pdf";